class GrassAPI {
  constructor({ axios, activeFarm }) {
    this.axios = axios;
    this.activeFarm = activeFarm;
    this.eventListeners = {};
  }

  addEventListener = (event, listener) => {
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(listener);
  };

  removeEventListener = (event, listener) => {
    if (this.eventListeners[event]) {
      this.eventListeners[event] = this.eventListeners[event].filter(
        (l) => l !== listener
      );
    }
  };

  dispatchEvent = (event, data) => {
    if (this.eventListeners[event]) {
      this.eventListeners[event].forEach((listener) => listener(data));
    }
  };

  postEventFertiliser = (obj) => postEventFertiliser(this.axios, obj);
  postEventCoverMeasuure = (obj) => postEventCoverMeasuure(this.axios, obj);

  getWpClass = (date) => getWpClass(this.axios, date);

  getFarms = () => getFarms(this.axios);
  postFarm = async (obj) => {
    const result = await postFarm(this.axios, obj);
    this.dispatchEvent("postFarm", result);
    return result;
  };
  patchFarm = (id, obj) => patchFarm(this.axios, id, obj);
  deleteFarm = (id) => deleteFarm(this.axios, id);

  getField = (id) => getField(this.axios, id);
  getFields = (filter = {}) => getFields(this.axios, filter);
  postField = (obj) => postField(this.axios, obj);
  putField = (id, obj) => putField(this.axios, id, obj);
  deleteField = (id) => deleteField(this.axios, id);

  getRegionalForecastPredictions = () =>
    getRegionalForecastPredictions(this.axios);

  // Invitations & members
  validateInvitation = (token) => validateInvitation(this.axios, token);
  acceptInvitation = (token, email) => acceptInvitation(this.axios, token, email);
  getMembers = (farmId) => getMembers(this.axios, farmId);
  inviteMember = (farmId, payload) => inviteMember(this.axios, farmId, payload);
  revokeInvitation = (inviteId) => revokeInvitation(this.axios, inviteId);
  regenerateInviteToken = (inviteId) => regenerateInviteToken(this.axios, inviteId);
  removeMember = (accessId) => removeMember(this.axios, accessId);
  getMyInvitations = () => getMyInvitations(this.axios);
  acceptInvitationById = (inviteId, email) => acceptInvitationById(this.axios, inviteId, email);
  declineInvitation = (inviteId) => declineInvitation(this.axios, inviteId);

  // User sync
  syncUser = (email, name) => syncUser(this.axios, email, name);
}

async function del(axios, type, id) {
  const { data } = await axios.delete(`/${type}/${id}`);
  return data;
}

async function post(axios, type, obj) {
  const { data } = await axios.post(`/${type}`, obj);
  return data;
}

async function get(axios, type, options = {}) {
  const { data } = await axios.get(`/${type}`, options);
  return data;
}

async function put(axios, type, id, obj) {
  const { data } = await axios.put(`/${type}/${id}`, obj);
  return data;
}

async function patch(axios, type, id, obj) {
  const { data } = await axios.patch(`/${type}/${id}`, obj);
  return data;
}

const getWpClass = (axios, date) => get(axios, `circulation/${date}`);
const getRegionalForecastPredictions = (axios) =>
  get(axios, "circulation/regionalForecastPredictions");

const postEventFertiliser = (axios, obj) => post(axios, "eventfertiliser", obj);
const postEventCoverMeasuure = (axios, obj) =>
  post(axios, "eventcovermeasure", obj);

const getFarms = (axios) => get(axios, "farm");
const postFarm = (axios, obj) => post(axios, "farm", obj);
const patchFarm = (axios, id, obj) => patch(axios, "farm", id, obj);
const deleteFarm = (axios, id) => del(axios, "farm", id);

const getField = (axios, id) => get(axios, `field/${id}`);
const getFields = (axios, filter = {}) =>
  get(axios, "field", { params: { q: JSON.stringify(filter) } });
const postField = (axios, obj) => post(axios, "field", obj);
const putField = (axios, id, obj) => put(axios, "field", id, obj);
const deleteField = (axios, id) => del(axios, "field", id);

// Invitation helpers
const validateInvitation = (axios, token) =>
  get(axios, "invitation/validate", { params: { token } });

const acceptInvitation = (axios, token, email) =>
  post(axios, "invitation/accept", { token, email });

const getMembers = (axios, farmId) => get(axios, `invitation/farm/${farmId}/members`);

const inviteMember = (axios, farmId, payload) =>
  post(axios, `invitation/farm/${farmId}/invite`, payload);

const revokeInvitation = (axios, inviteId) => post(axios, `invitation/${inviteId}/revoke`, {});

const regenerateInviteToken = (axios, inviteId) => post(axios, `invitation/${inviteId}/regenerate`, {});

const removeMember = (axios, accessId) => post(axios, `invitation/member/${accessId}/remove`, {});

const getMyInvitations = (axios) => get(axios, 'invitation/my-invitations');

const acceptInvitationById = (axios, inviteId, email) => post(axios, `invitation/${inviteId}/accept-by-id`, { email });

const declineInvitation = (axios, inviteId) => post(axios, `invitation/${inviteId}/decline`, {});

// User helpers
const syncUser = (axios, email, name) => post(axios, 'user/sync', { email, name });

export default GrassAPI;
